import axiosClient from './AxiosClient';
import {
  PreviewingReservationDetailResponseDto,
  PreviewingReservationResponseDto,
  PreviewingControllerFindReservationRequest,
  CreatePreviewingReservationDto,
  UpsertCustomerDto,
} from './generated/openapi';

const PreviewingReservationService = {
  getPreviewingReservation(
    params: PreviewingControllerFindReservationRequest,
  ): Promise<PreviewingReservationDetailResponseDto> {
    return axiosClient
      .get<PreviewingReservationDetailResponseDto>(
        `/previewing_reservation/previewing_get/${params.reservationId}`,
      )
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to fetch data: ${error}`);
      });
  },

  confirmPreviewingReservation(param: string): Promise<CreatePreviewingReservationDto> {
    return axiosClient
      .patch<CreatePreviewingReservationDto>(`/previewing_reservation/confirm/${param}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to patch data: ${error}`);
      });
  },

  deletePreviewingReservation(param: string): Promise<PreviewingReservationResponseDto> {
    return axiosClient
      .delete<PreviewingReservationResponseDto>(`/previewing_reservation/delete/${param}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to delete data: ${error}`);
      });
  },

  createCustomer(reservationId: string, params: UpsertCustomerDto) {
    return axiosClient
      .post(`/previewing_reservation/customer-create/${reservationId}`, params)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(`Failed to create customer data: ${error}`);
      });
  },
};

export default PreviewingReservationService;
